module.exports = Em.Component.extend({
    layoutName: 'components/maintenance-bar'
})
